import { render, staticRenderFns } from "./FoodieJournal.vue?vue&type=template&id=44a144b8&scoped=true&"
import script from "./FoodieJournal.vue?vue&type=script&lang=js&"
export * from "./FoodieJournal.vue?vue&type=script&lang=js&"
import style0 from "./FoodieJournal.vue?vue&type=style&index=0&id=44a144b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a144b8",
  null
  
)

export default component.exports